import { QuestionUsersController } from './question-users.controller';

export const QuestionUsersComponent: ng.IComponentOptions = {
  bindings: {
    question: '<',
    hasError: '<',
    questionOptions: '<',
    answers: '=',
    actionClickedFn: '=?',
    previousAnswers: '<',
    unconfirmedPrefilledQuestions: '<',
    isDisabled: '<?',
  },
  require: {
    sfQuestionForm: '^sfQuestionForm',
  },
  templateUrl:
    'missions/components/Form-questions/question-users/question-users.html',
  controller: QuestionUsersController,
};
